import { useEffect } from 'react';
import { Toast, ToastContainer, Button } from 'react-bootstrap';

const ToastItem = ({ toast, onClose }) => {
    useEffect(() => {
        if (toast.show && toast.autoHide !== false) {
            const timer = setTimeout(() => {
                onClose();
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [toast.show, toast.autoHide, onClose]);

    return (
        <Toast show={toast.show} onClose={onClose} className="pt-3 px-4 pb-4">
            <Toast.Header closeButton={true} className="border-0 pb-0">
                <div className='w-100'></div>
            </Toast.Header>
            <Toast.Body className="pt-0">
                <div className="text-center pb-3 w-100 text-lg-bold">
                    {toast.title}
                </div>
                {
                    toast.message.split("\n").map((p, i) => <p key={i}>{p}</p>)
                }
                {toast.action && (
                    <div className="mt-3">
                        <Button 
                            className='racq-primary-btn w-100'
                            variant={toast.action.variant || 'primary'}
                            onClick={() => {
                                toast.action.onClick();
                                onClose();
                            }}
                        >
                            {toast.action.label}
                        </Button>
                        <Button 
                            className='w-100 mt-3'
                            variant="outline-secondary"
                            onClick={onClose}
                        >
                            Cancel
                        </Button>
                    </div>
                )}
            </Toast.Body>
        </Toast>
    );
};

// Combined Toast Notifications Container
const ToastNotifications = ({ toasts, onCloseToast }) => {
    // Separate toasts by type for different positioning
    const sessionExpiredToasts = toasts.filter(toast => toast.type === 'sessionExpiredWithAction');
    const regularToasts = toasts.filter(toast => toast.type !== 'sessionExpiredWithAction');

    return (
        <>
            {/* Regular toasts - top-right corner */}
            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1050 }}>
                {regularToasts.map((toast) => (
                    <ToastItem
                        key={toast.id}
                        toast={toast}
                        onClose={() => onCloseToast(toast.id)}
                    />
                ))}
            </ToastContainer>

            {/* Session expired toasts - center of screen */}
            {sessionExpiredToasts.length > 0 && (
                <div 
                    className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ 
                        top: 0, 
                        left: 0, 
                        zIndex: 1055,
                        pointerEvents: 'none' // Allow clicks through the backdrop
                    }}
                >
                    <div style={{ pointerEvents: 'auto' }}>
                        {sessionExpiredToasts.map((toast) => (
                            <ToastItem
                                key={toast.id}
                                toast={toast}
                                onClose={() => onCloseToast(toast.id)}
                            />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ToastNotifications;
